export default __webpack_public_path__ + "1b2a3ba8980621bf3f2d6a6ffafea02f.svg";